import React from 'react'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';

// components
import {
  CCol,
  CFormLabel,
} from '@coreui/react-pro'

const FormSelectInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  selectOptions,
  value,
  handleSelectInput,
  handleSearchInput,
  feedbackInvalid,
  invalid,
  disabled,
  isShowLabel = true,
  isShowInvalidErr = true,
  placeholder,
  componentSelect,
  isDetectSearch = false,
  multiple = false,
  isClearable = true,
  isShowCreatedModal = false,
  noOptionsMessageText = 'No Options',
  createOptionLabel = (inputValue) => inputValue ? `Add "${inputValue}"` : 'Add New',
  isCreatable = false,
  handleShowModalCreate
}) => {
  // Custom NoOptionsMessage component (tetap ada untuk fallback)
  const CustomNoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        {noOptionsMessageText}
      </components.NoOptionsMessage>
    );
  };

  // Custom MenuList: selalu tampilkan tombol "Add New" di atas list
  const CustomMenuList = (props) => {
    const inputValue = props?.selectProps?.inputValue || '';
    const selectName = props?.selectProps?.name;

    return (
      <components.MenuList {...props}>
        {isShowCreatedModal && (
          <div
          className="d-flex justify-content-start align-items-center px-3 py-2"
          style={{ borderTop: '1px solid #e0e0e0', marginTop: '4px' }}
          >
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={() => handleShowModalCreate(selectName, inputValue)}
              type="button"
              size="sm"
            >
              + {createOptionLabel(inputValue)}
            </button>
          </div>
        )}
        {props.children}
      </components.MenuList>
    );
  };

  return (
    <CCol lg={colSize} className={className}>
      {
        isShowLabel && (
          <CFormLabel>
            {inputLabel}
          </CFormLabel>
        )
      }
      {
        isCreatable ? (
          <CreatableSelect
            id={id}
            name={name}
            isMulti={multiple}
            options={selectOptions}
            className={`${invalid ? 'select-invalid' : ''}`}
            onChange={(e) => handleSelectInput(e)}
            onInputChange={(e) => {
              if (isDetectSearch) {
                handleSearchInput(e)
              }
            }}
            value={value}
            isDisabled={disabled}
            isSearchable={true}
            isClearable={isClearable}
            placeholder={placeholder}
            components={{ ...componentSelect, NoOptionsMessage: CustomNoOptionsMessage }}
          />
        ) : (
          <Select
            id={id}
            name={name}
            isMulti={multiple}
            options={selectOptions}
            className={`${invalid ? 'select-invalid' : ''}`}
            onChange={(e) => handleSelectInput(e)}
            onInputChange={(e) => {
              if (isDetectSearch) {
                handleSearchInput(e)
              }
            }}
            value={value}
            isDisabled={disabled}
            isSearchable={true}
            isClearable={isClearable}
            placeholder={placeholder}
            components={{
              ...componentSelect,
              NoOptionsMessage: CustomNoOptionsMessage,
              MenuList: CustomMenuList
            }}
          />
        )
      }
      {
        isShowInvalidErr && invalid && (
          <span className='error-text-field'>{feedbackInvalid || feedbackInvalid?.name}</span>
        )
      }
    </CCol>
  )
}

export default FormSelectInput
